import { useEffect } from "react";
import "./App.scss";
import { _globalService } from "./services/_global.service";
import Chart from "./chart/chart";
import { useDebugMode, useTheme } from "./hooks/global.hooks";
import Debug from "./debug/debug";
import { usePriceWS } from "./hooks/ws.hook";
import { _rpcService } from "./services/_rpc.service";

function App() {
  const { theme } = useTheme();
  const { debugMode } = useDebugMode();
  useEffect(() => {
    _globalService.initService();
    _rpcService.init();
  }, []);

  usePriceWS();

  return (
    <div
      className={`tr-${theme}-theme main-container ${debugMode ? "debug" : ""}`}
    >
      <Chart />
      {debugMode && <Debug />}
    </div>
  );
}

export default App;
